export default __webpack_public_path__ + "static/media/baunebakken-property-04.a5a36691.jpg";